import { createLazyComponent, LazyAction, LazyModule, type LazyComponent } from "owa-bundling";
import { isCalendarSchedulingDialogOpen } from "owa-calendar-scheduling-dialog-store";
import { GovernPriority } from "owa-client-types/lib/GovernPriority";
import type * as lazyIndex from "./lazyIndex";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "CalendarSchedulingDialog" */ "./lazyIndex"), { name: "CalendarSchedulingDialog", govern: GovernPriority.Calendar });

export type { GetSchedulingDraftProps } from "./types/GetSchedulingDraftProps";

/**
 * Lazily requests a scheduling draft without persisting a task or opening calendar compose.
 * Use the email mode to ground the request in a specific message.
 */
export const lazyGetSchedulingDraft: LazyAction<typeof lazyIndex.getSchedulingDraft, typeof lazyModule> = new LazyAction(lazyModule, m => m.getSchedulingDraft);

/** Loads the scheduling dialog UI only when the dialog store indicates it is open. */
export const CalendarSchedulingDialog: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.CalendarSchedulingDialog, undefined, undefined, {
    onlyImportIf: isCalendarSchedulingDialogOpen,
});
